import React from 'react';
import './UserPageHeader.scss';

export type UserPageHeaderProps = {
    icon: React.ReactNode;
    title: string;
};

export const UserPageHeader: React.FC<UserPageHeaderProps> = ({ icon, title }) => {
    return (
        <div className="user-page-header">
            <span className="user-page-header__icon" aria-hidden="true">{icon}</span>
            <h1 className="user-page-header__title">{title}</h1>
        </div>
    );
};
